const USER_ROLES = {
  "seller": "seller",
  "dealer": "dealer",
  "buyer": "buyer",
  "admin": "admin",
  "agent": "agent"
};

export {
  USER_ROLES,
};